import React from 'react'
import styles from './index.module.scss'

const describe = (error) => {
    if (error.generic || !error.title_ru) return 'Одно из блюд стало недоступно'
    if (error.quantity_left > 0) return `«${error.title_ru}» — осталось только ${error.quantity_left} порц.`
    return `«${error.title_ru}» закончилось`
}

const OutOfStockPopup = ({ errors, onClose }) => {
    if (!errors || errors.length === 0) return null

    return (
        <div className={styles.overlay}>
            <div className={styles.popup}>
                <div className={styles.title}>Не всё получилось заказать</div>
                <ul className={styles.list}>
                    {errors.map((error, i) => (
                        <li key={i}>{describe(error)}</li>
                    ))}
                </ul>
                <div className={styles.subtitle}>Уберите или замените эти блюда в заказе и повторите отправку</div>
                <div className={styles.confirm} onClick={onClose}>Понятно</div>
            </div>
        </div>
    )
}

export default OutOfStockPopup
